import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChargingStation } from '@models/charging-station';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DiagnosticChargingStationDialogContentComponent } from './diagnostic-charging-station-dialog-content/diagnostics-charging-station-dialog-content.component';
@Component({
  selector: 'app-diagnostics-charging-station-dialog',
  template: ''
})
export class DiagnosticChargingStationDialogComponent implements OnInit {

  private chargingStationId: string;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      if (this.chargingStationId == null) {
        this.chargingStationId = params.get('key');
      }
      this.openDialog();
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DiagnosticChargingStationDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.entity = this.chargingStationId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
